import React, { Component } from 'react';
import classNames from 'classnames';
import isArray from 'lodash.isarray';
import IconChevron from '../atoms/IconChevron';

class Gallery extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      activeIndex: 0,
      images: [],
    }
  }

  setImages = () => {
    let images = [];

    if ( this.props.featuredImage ) {
      images.push(this.props.featuredImage);
    }

    if ( this.props.images ) {
      if ( isArray( this.props.images ) && this.props.images.length ) {
        images = images.concat(this.props.images);
      }
      else {
        images.push(this.props.images);
      }
    }

    this.setState({ images });
  };

  componentDidMount() {
    this.setImages();
  }

  componentDidUpdate( prevProps ) {
    if ( this.props.images !== prevProps.images || this.props.featuredImage !== prevProps.featuredImage ) {
      this.setImages();
    }
  }

  moveNext = () => {
    if ( this.state.activeIndex === this.state.images.length - 1 ) {
      this.setState( {
        activeIndex: 0,
      } );
    } else {
      this.setState( {
        activeIndex: this.state.activeIndex + 1,
      } );
    }
  };

  movePrev = () => {
    if ( this.state.activeIndex === 0 ) {
      this.setState( {
        activeIndex: this.state.images.length - 1,
      } );
    } else {
      this.setState( {
        activeIndex: this.state.activeIndex - 1,
      } );
    }
  };

  render() {
    if ( this.state.images.length > 0 ) {
      return (
        <div className="Gallery">
          <div className="GalleryImages">
          {this.state.images.length > 1 && (
            <div className="buttons">
              <button className="prev" type="button" onClick={this.movePrev}><IconChevron/></button>
              <button className="next" type="button" onClick={this.moveNext}><IconChevron/></button>
            </div>
          )}
          {this.state.images.map( ( image, i ) => {
            let classes = classNames( { 'active': this.state.activeIndex === i } );
            return (
              <img className={classes} key={i} alt={image.alt} src={image.src} title={image.title} onClick={this.moveNext}/>
            )
          } )}
          </div>
          <div className="GalleryNav">
            <p className="small">{this.state.images[this.state.activeIndex].alt}</p>
            <p className="small">{this.state.activeIndex + 1} of {this.state.images.length}</p>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default Gallery;